import Vue from "vue";
// import moment from "moment";
import { isEmpty, hashCode, arrayToObj } from "../../lib/utilities";
import { Colors, CoreUserStatus } from "@/lib/utilities/enums";

function initialState() {
  return {
    appUsers: [],
    isLoadingUsers: false,
    orgGroups: [],
    filterCriteria: {
      orgCriteria: [],
      platformCriteria: [],
      filterText: "",
      isValid: false
    },
    AlertMinerRoles: []
  };
}
const state = initialState();

const getters = {
  appUsers(state) {
    return state.appUsers;
  },
  orgGroups(state) {
    return state.orgGroups || [];
  },
  AlertMinerRoles(state) {
    return state.AlertMinerRoles;
  },
  AlertMinerRolesMappedByName(state) {
    return arrayToObj(state.AlertMinerRoles, "Name");
  },
  employeesOnly(state, getters, rootState, rootGetters) {
    if ((state.appUsers || []).length == 0 || (rootGetters.User.ViewAllowedStores || []).length == 0) return [];

    const allowedStoreIds = rootGetters.User.ViewAllowedStores.map(vas => vas.AccountPlatformID);
    const employees = state.appUsers.filter(usr => usr.HasAllPlatformAccess || (usr.AccountPlatformIDs || [usr.AccountPlatformID]).some(platformId => allowedStoreIds.includes(platformId)));

    // UserType: 10 - Bot, 20 - User
    return employees.filter(emp => emp.UserType != 10 && emp.UserId != 9999999 && !emp.UserId.startsWith("PS"));
  },
  getStoreUsers: (state, getters) => (platformId, activeOnly) => {
    return getters.employeesOnly.filter(emp => (emp.HasAllPlatformAccess || (emp.AccountPlatformIDs || [emp.AccountPlatformID]).includes(platformId)) && (!activeOnly || emp.UserStatus == CoreUserStatus.Active));
  },
  getAppUser: (state, getters, rootState, rootGetters) => userId => {
    // TODO: Use accountUsersDictionary getter in the caller instead
    return rootGetters.accountUsersDictionary[userId];
  }
};

const actions = {
  getOrgGroups(context) {
    return new Promise((resolve, reject) => {
      if (!context.getters.orgGroups || context.getters.orgGroups.length == 0) {
        Vue.http
          .get("/core/groups/org")
          .then(function (data) {
            context.commit("getOrgGroups", data.data.Data);
            resolve(data.data.Data);
          })
          .catch(function (error) {
            reject(error);
          });
      } else {
        resolve(context.getters.orgGroups);
      }
    });
  },
  // async getAllUsers(context) {
  //   context.dispatch("getDealershipUsers");
  //   // commit("updateLoadingUsersStatus", true);
  //   // const response = await Vue.http.get("/core/users?returnAllAccountUsers=true&returnAllAccountUsers=true").catch(err => err.response);
  //   // commit("updateLoadingUsersStatus", false);

  //   // if (response && response.data && response.data.Data) {
  //   //   const payload = {
  //   //     userId: rootGetters.User.Id,
  //   //     color: rootGetters.User.AvatarBGColor,
  //   //     data: response.data.Data
  //   //   };
  //   //   commit("setAppUsers", payload);
  //   // }
  // },
  async getDealershipUsers(context) {
    context.commit("updateLoadingUsersStatus", true);
    let allUsers = [];
    const pageSize = 500;

    // const startDT = moment();
    // console.log("Loading page: 1");;
    const firstPageData = await context.dispatch("getDealershipUsersByPage", {
      page: 0,
      size: pageSize
    });
    // console.log("Loaded page: 1");

    if ((firstPageData || []).length > 0) {
      allUsers = firstPageData;
      const pageCount = Math.ceil(firstPageData[0].MatchedCount / pageSize);

      if (pageCount > 1) {
        // console.log("Found multiple pages: ", pageCount);
        const pages = [...Array(pageCount).keys()];
        let pageCalls = [];

        for (let page of pages) {
          if (page == 0) continue;

          pageCalls.push(context.dispatch("getDealershipUsersByPage", {
            page: page,
            size: pageSize
          }));
        }

        // console.log("Loading multiple pages: ", new Date());
        const pageResponses = await Promise.all(pageCalls);

        for (let pageResponse of pageResponses) {
          if ((pageResponse || []).length == 0) continue;
          allUsers = allUsers.concat(pageResponse);
        }

        // console.log("Loaded multiple pages: ", new Date());
      }
    }

    const payload = {
      userId: context.getters.User.Id,
      color: context.getters.User.AvatarBGColor,
      data: allUsers
    };
    context.commit("setAppUsers", payload);

    // const endDT = moment();
    // console.log("Time elapsed: ", endDT.diff(startDT, 'seconds'));
    // console.log("Loaded all users: ", allUsers.length);
    // console.log("Loaded all users: ", allUsers.map(usr => usr.LastName));

    context.commit("updateLoadingUsersStatus", false);
  },
  async getDealershipUsersByPage(context, request) {
    try {
      const pagedQuery = `from=${request.page*request.size}&size=${request.size}&orderBy=LastName&orderDir=asc&returnAllAccountUsers=true`;

      const response = await Vue.http.get(`/core/users?${pagedQuery}`).catch(err => err.response);
      if (!response || !response.data || !response.data.Data) {
        console.log("No users found for query: ", pagedQuery);
        return [];
      } else return response.data.Data;
    } catch (err) {
      console.log("Error loading users for request: ", request);
    }
  },
  userUpdated(context, val) {
    context.commit("userUpdated", val);
    if (val.Id == context.getters.user.Id) {
      val.IsFavorite = context.getters.user.IsFavorite;
      // context.dispatch("updateCurrentUser", val); // Not sure what this is, it doesn't exist
    }
  },
  handleUserFavoriteResponse(context, val) {
    context.commit("handleUserFavoriteResponse", val);
    if (val.Id == context.getters.user.Id) {
      // context.dispatch("updateCurrentUser", val); // Not sure what this is, it doesn't exist
    }
  },
  async getAlertMinerRoles(context) {
    const response = await Vue.http.get("/RolePermissions/GetAlertMinerRoles").catch(err => err.response);
    if (response && response.data && response.data.Success)
      context.commit("setAlertMinerRoles", (response.data.Data || []).filter(f => f.IsActive));
  },
  async getUsersWithPermission(context, request) {
    let url = `/core/users/withpermissions?accountPlatformId=${request.platformId}&status=${request.status}`;
    let response = await Vue.http.post(url, request.permissions);
    return response && response.data ? response.data.Data : [];
  },
  async getUserWizard(context, userId) {
    let response = await Vue.http.get("/core/users/wizarduser/" + userId);
    return response && response.data ? response.data.Data : null;
  }
};

const mutations = {
  setAppUsers(state, payload) {
    try {
      if (payload.data && payload.data.length > 0) {
        for (let usr of payload.data) {
          usr.Name = usr.Name ? usr.Name.trim() : usr.Name;
          if ((usr.AccountPlatformIDs || []).length == 0) usr.AccountPlatformIDs = [usr.AccountPlatformID];

          // TODO: Replace references to these props and remove
          usr.account = usr.Account;
          usr.accountPlatformID = usr.AccountPlatformID;
          usr.id = usr.Id;
          usr.name = usr.Name;
          usr.userId = usr.UserId;
          usr.userType = usr.UserType;
          usr.userStatus = usr.UserStatus;

          // Set avatar bg color
          if (usr.Id == payload.userId) {
            usr.AvatarBGColor = payload.color;
          } else {
            let name = usr.Name || usr.name;
            const randomInt = Math.abs(hashCode(name)) % Colors.length;
            //These will be used for users with no avatar
            const color = Colors[randomInt];
            usr.AvatarBGColor = color || Colors[0];
          }
        }

        payload.data.sort((usr1, usr2) => {
          if (usr1.Active == usr2.Active) return (usr1.Name || "").toLowerCase() > (usr2.Name || "").toLowerCase() ? 1 : -1;
          else return usr1.Active ? -1 : 1;
        });
      }

      state.appUsers = payload.data;
    } catch (err) {
      console.log("Error setting app users: ", err);
    }
  },
  userUpdated(state, val) {
    if (val && val.Id) {
      let userObj = state.appUsers.find(function (usr) {
        return usr.Id == val.Id;
      });

      if (userObj && userObj.Id) {
        let color = userObj.AvatarBGColor;
        let isFavorite = userObj.IsFavorite;
        for (let prop in val) {
          try {
            userObj[prop] = val[prop];
          } catch (err) {
            console.log("Error copying property");
          }
        }
        userObj.AvatarBGColor = color;
        userObj.IsFavorite = isFavorite;
      } else {
        let name = val.Name || val.name;
        let randomInt = Math.abs(hashCode(name)) % Colors.length;
        //These will be used for users with no avatar
        let color = Colors[randomInt];
        val.AvatarBGColor = color || Colors[0];

        if (!state.appUsers || state.appUsers.length == 0) state.appUsers = [];

        state.appUsers.push(val);
      }
    }
  },
  handleUserFavoriteResponse(state, val) {
    if (val && val.Id) {
      let userObj = state.appUsers.find(function (usr) {
        return usr.Id == val.Id;
      });

      if (userObj && userObj.Id) {
        userObj.IsFavorite = val.IsFavorite;
      }
    }
  },
  getOrgGroups(state, val) {
    state.orgGroups = val;
  },
  updateLoadingUsersStatus(state, val) {
    state.isLoadingUsers = val;
  },
  setAlertMinerRoles(state, val) {
    state.AlertMinerRoles = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/TeamDirectory.js